import { render, staticRenderFns } from "./SGPFormDataComponent.vue?vue&type=template&id=73599886&scoped=true"
import script from "./SGPFormDataComponent.vue?vue&type=script&lang=js"
export * from "./SGPFormDataComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPFormDataComponent.vue?vue&type=style&index=0&id=73599886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73599886",
  null
  
)

export default component.exports